import { EnumExamHistologicalResult } from 'generated/graphql';

export const availableTechnology = process.env.REACT_APP_AVAILABLE_PRODUCT;

export const TECHNOLOGIES = {
  deepCapsule: 'deepCapsule',
  smartCholangio: 'smartCholangio',
  smartCyst: 'smartCyst',
  smartPancreas: 'smartPancreas',
  anoscopyGenius: 'anoscopyGenius',
} as const;

export type TTechnology = (typeof TECHNOLOGIES)[keyof typeof TECHNOLOGIES];

export const TECHNOLOGY_GROUPS = {
  capsule: 'capsule',
  detection: 'detection',
  pancreas: 'pancreas',
} as const;

export type TTechnologyGroups =
  (typeof TECHNOLOGY_GROUPS)[keyof typeof TECHNOLOGY_GROUPS];

export const TECHNOLOGIES_BY_GROUP: Record<TTechnologyGroups, TTechnology[]> = {
  capsule: [TECHNOLOGIES.deepCapsule],
  detection: [
    TECHNOLOGIES.smartCholangio,
    TECHNOLOGIES.smartCyst,
    TECHNOLOGIES.smartPancreas,
    TECHNOLOGIES.anoscopyGenius,
  ],
  pancreas: [TECHNOLOGIES.smartPancreas, TECHNOLOGIES.smartCyst],
};

// All available technologies, including groups
export const TECHNOLOGIES_AND_GROUPS = [
  ...Object.values(TECHNOLOGIES),
  ...Object.values(TECHNOLOGY_GROUPS),
];

export type TTechnologiesAndGroups = TTechnologyGroups | TTechnology;

export const DEEP_CAPSULE_MODELS = {
  MAIN: 'deep_capsule',
  LIGHT: 'deep_capsule_light',
} as const;

export const SMART_CHOLANGIO_MODELS = {
  MAIN: 'smart_cholangio',
} as const;

export const SMART_CYST_MODELS = {
  MAIN: 'smart_cyst',
} as const;

export const SMART_PANCREAS_MODELS = {
  MAIN: 'smart_pancreas',
} as const;

export const ANOSCOPY_GENIUS_MODELS = {
  MAIN: 'anoscopy_genius',
} as const;

export const DEEP_CAPSULE_MODEL =
  process.env.REACT_APP_DEEP_CAPSULE_MODEL ?? DEEP_CAPSULE_MODELS.MAIN;

export const SMART_CHOLANGIO_MODEL =
  process.env.REACT_APP_SMART_CHOLANGIO_MODEL ?? SMART_CHOLANGIO_MODELS.MAIN;

export const SMART_CYST_MODEL =
  process.env.REACT_APP_SMART_CYST_MODEL ?? SMART_CYST_MODELS.MAIN;

export const SMART_PANCREAS_MODEL =
  process.env.REACT_APP_SMART_PANCREAS_MODEL ?? SMART_PANCREAS_MODELS.MAIN;

export const ANOSCOPY_GENIUS_MODEL =
  process.env.REACT_APP_ANOSCOPY_GENIUS_MODEL ?? ANOSCOPY_GENIUS_MODELS.MAIN;

export const TECHNOLOGY_MODELS = {
  [TECHNOLOGIES.smartCholangio]: SMART_CHOLANGIO_MODEL,
  [TECHNOLOGIES.deepCapsule]: DEEP_CAPSULE_MODEL,
  [TECHNOLOGIES.smartCyst]: SMART_CYST_MODEL,
  [TECHNOLOGIES.smartPancreas]: SMART_PANCREAS_MODEL,
  [TECHNOLOGIES.anoscopyGenius]: ANOSCOPY_GENIUS_MODEL,
};

export const TECHNOLOGY_UPLOAD_MAX_FILES = {
  [TECHNOLOGIES.smartCholangio]: 25,
  [TECHNOLOGIES.deepCapsule]: 1,
  [TECHNOLOGIES.smartCyst]: 25,
  [TECHNOLOGIES.smartPancreas]: 25,
  [TECHNOLOGIES.anoscopyGenius]: 25,
};

export const DEEP_CAPSULE_TARGET = {
  P3: 'Blood / Hematic residues',
  P1E: 'Erosions',
  P1U: 'Ulcers - Low Hemorrhagic Potential',
  P2U: 'Ulcers - High Hemorrhagic Potential',
  P1V: 'Vascular lesions - Low Hemorrhagic Potential (Redspots)',
  P2V: 'Vascular lesions - High Hemorrhagic Potential',
  P1PR: 'Protruding lesions - Low Hemorrhagic Potential',
  P2PR: 'Protruding Lesions - High Hemorrhagic Potential',
  P0X: 'Xanthelasmas',
  P0L: 'Lymphagiectasia / Nodular Lymphoid',
} as const;

export const DEEP_CAPSULE_LIGHT_TARGET = {
  BL: 'Blood / Hematic residues',
  V: 'Vascular lesions',
  EU: 'Ulcers / Erosions',
  PR: 'Protruding lesions',
  XL: 'Xanthelasmas / Lymphagiectasias',
} as const;

export type TExamHistologicalResultValue = EnumExamHistologicalResult | null;

export const EXAM_HISTOLOGICAL_RESULT_LABELS = {
  [EnumExamHistologicalResult.B]: 'Benign Endoscopic Pattern',
  [EnumExamHistologicalResult.M]: 'Malignant Endoscopic Pattern',
} as const;

export const LESION_DIFFERENTIATION =
  process.env.REACT_APP_LESION_DIFFERENTIATION === 'true';

export const VALIDATION_ENABLED =
  process.env.REACT_APP_VALIDATION_ENABLED === 'true';

export const FILTER_BEFORE_PREDICTION =
  process.env.REACT_APP_FILTER_BEFORE_PREDICTION === 'true';

export const EVALUATE_CLEANSING =
  process.env.REACT_APP_EVALUATE_CLEANSING === 'true';

export const PRODUCT_VERSIONS = {
  [TECHNOLOGIES.deepCapsule]: process.env.REACT_APP_DEEP_CAPSULE_VERSION,
  [TECHNOLOGIES.smartCholangio]: process.env.REACT_APP_SMART_CHOLANGIO_VERSION,
  [TECHNOLOGIES.smartCyst]: process.env.REACT_APP_SMART_CYST_VERSION,
  [TECHNOLOGIES.smartPancreas]: process.env.REACT_APP_SMART_PANCREAS_VERSION,
  [TECHNOLOGIES.anoscopyGenius]: process.env.REACT_APP_ANOSCOPY_GENIUS_VERSION,
};
